export default "__VITE_ASSET__oVIz3r$w__"